import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="w-full py-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-bold text-lg mb-3">PixelShift</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Fast, private, and free WEBP & HEIC converter. Perfect for iPhone photos. Your images never leave your browser.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-3">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-brand-primary transition-colors">
                  Blog & Guides
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-brand-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-brand-primary transition-colors">
                  WEBP Converter
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Articles */}
          <div>
            <h3 className="text-white font-bold text-lg mb-3">Popular Articles</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/blog/how-to-convert-webp-to-jpg" className="text-gray-400 hover:text-brand-primary transition-colors">
                  How to Convert WEBP to JPG
                </Link>
              </li>
              <li>
                <Link to="/blog/best-webp-converter" className="text-gray-400 hover:text-brand-primary transition-colors">
                  Best WEBP Converters
                </Link>
              </li>
              <li>
                <Link to="/blog/how-to-open-webp-files" className="text-gray-400 hover:text-brand-primary transition-colors">
                  How to Open WEBP Files
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-gray-800 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} PixelShift. All Rights Reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            100% client-side conversion • No uploads • Privacy first
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

